import { forwardRef } from "react";
import { SelectorAvatarStack } from "./selector-avatar";
import {
  SelectorPlaceholder,
  SelectorTrigger,
  SelectorTriggerLabel,
} from "./selector-trigger";
import type { SelectorGroup, SelectorTriggerProps } from "./types";

export interface GroupSelectProps extends Omit<SelectorTriggerProps, "value"> {
  value?: SelectorGroup;
}

export const GroupSelect = forwardRef<HTMLButtonElement, GroupSelectProps>(
  function GroupSelect(
    { value, placeholder = "Select a brand group", size = "md", ...props },
    ref
  ) {
    return (
      <SelectorTrigger
        ref={ref}
        placeholder={placeholder}
        size={size}
        {...props}
      >
        {!value ? (
          <SelectorPlaceholder>{placeholder}</SelectorPlaceholder>
        ) : (
          <span className="flex min-w-0 flex-1 items-center gap-1.5">
            <SelectorAvatarStack
              accounts={(value.accounts || []).slice(0, 4)}
              max={4}
              size={24}
            />
            <SelectorTriggerLabel
              className="text-neutral-800"
              suffix={
                (value.accounts?.length ?? 0) > 1 ? (
                  <span
                    aria-hidden
                    className="ml-1.5 text-neutral-500 tabular-nums"
                  >
                    {`· ${value.accounts?.length}`}
                  </span>
                ) : undefined
              }
            >
              {value.label}
            </SelectorTriggerLabel>
            {/* No members supplied means the count is unknown, not zero. */}
            {value.accounts ? (
              <span className="sr-only">
                {value.accounts.length === 1
                  ? "1 account"
                  : `${value.accounts.length} accounts`}
              </span>
            ) : null}
          </span>
        )}
      </SelectorTrigger>
    );
  }
);
